import { Tabs, TabsProps } from "@mantine/core";

export const EducacionTabs = (props: TabsProps) => {
  return (
    <Tabs
      unstyled
      styles={(theme) => ({
        tab: {
          backgroundColor: "#d4d4d4",
          color: theme.colors.gray[9],
          border: `1px solid ${theme.colors.gray[4]}`,
          padding: `${theme.spacing.xs} ${theme.spacing.lg}`,
          cursor: "pointer",
          fontSize: theme.fontSizes.sm,
          alignItems: "center",
          margin: "0px 10px",
          borderRadius: theme.radius.xl,
          fontWeight: 600,

          "&:disabled": {
            opacity: 0.5,
            cursor: "not-allowed",
          },
          
          // No funciona
          // "&:data-active": {
          //   backgroundColor: theme.colors.dark[9], // Black background
          //   color: theme.white, // White text color
          // },
        },

        tabIcon: {
          marginRight: theme.spacing.xs,
          display: "flex",
          alignItems: "center",
        },

        tabsList: {
          display: "flex",
        },
      })}
      {...props}
    />
  );
};
